import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const categories = [
  {
    name: "Nuts",
    image: "/assets/product-images/Nuts.jpg",
  },
  {
    name: "Chocolate",
    image: "/assets/product-images/Chocolate.jpg",
  },
  {
    name: "Fruits",
    image: "/assets/product-images/Fruits.jpg",
  },
  {
    name: "Others",
    image: "/assets/product-images/Others.jpg",
  },
];

function Categories() {
  return (
    <section className="categories-con position-relative">
      <div className="container">

        {/* TITLE */}
        <motion.div
          className="text-center categories_content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h2>
            Explore Our <span>CategorieS</span>
          </h2>
          <p>
            Discover our handcrafted gelato flavors, made with fresh ingredients and perfect for every craving.
          </p>
        </motion.div>

        {/* CATEGORIES */}
        <div className="row mt-4">
          {categories.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-sm-6 mb-4" key={index}>
              
              <div className="categories-box">

                <figure className="image mb-0">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="img-fluid"
                  />
                </figure>

                <div className="content d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">{item.name}</h5>

                  <Link to={`/products/${item.name.toLowerCase()}`}>
                    <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </div>

              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Categories;